import React, { useState, useEffect, useRef, useContext } from "react";
import "./style/OTPToken.module.scss";
import "react-phone-input-2/lib/style.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import FInput from "../../components/FInput/FInput";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import FiconPhoneNumber from "../../components/FiconPhoneNumber/FiconPhoneNumber";
import Swal from "sweetalert2";
import Floading from "../../components/Floading/Floading";
import { contactInfoSave } from "../../api/contactInfo";
import { AuthContext } from "../../context/AuthContext";
import FInputt from "../../components/FInputt/FInputt";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import FContainer from "../../components/FContainer/FContainer";
import { useContactInfo } from "../../hooks/useContactInfo";

const OTPToken = ({ screen = "", parameters }) => {
  const { checkToken, setLoading } = useContext(AuthContext);
  const [_expirationTime, setexpirationTime] = useState();
  const [_waitingTime, setwaitingTime] = useState();
  const route = useNavigate();
  const { sendOtpEmail, sendOtpPhone } = useContactInfo();


  useEffect(() => {
    _SingUpSendCode();
  }, []);

  let expirationTime = 0;
  let waitingTime = 0;
  let idTimerExpirationTime = useRef(0);
  let idTimerWaitingTime = useRef(0);
  async function _SingUpSendCode() {
    let res = "";

    if (screen == "PhoneOTPScreen") {
      let dataSendOtpEmail = await sendOtpPhone(parameters.contact);
      console.log("dataSendOtpEmail",dataSendOtpEmail)
      res = dataSendOtpEmail;
    }
    if (screen == "EmailOTPScreen") {
      let dataSendOtpEmail = await sendOtpEmail(parameters.contact);
      console.log("dataSendOtpEmail",dataSendOtpEmail)
      res = dataSendOtpEmail;
    }

    console.log("res", res);

    if (res.status == "Bad Request.") {
      Swal.fire({
        showCloseButton: true,
        title: 'Advertencia',
        text: "Su solicitud no puede ser procesada",
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        iconColor: "#fd6e0d",
        confirmButtonText: 'Entendido'
      }).then((result) => {
        if (result.isConfirmed) {
          route(-1);
        } else {
          route(-1);
        }
      });
    }

    if (res.status == "PROCESS_OK") {
      clearInterval(idTimerExpirationTime.current);
      clearInterval(idTimerWaitingTime.current);
      expirationTime = res.data.expirationTime;
      waitingTime = res.data.waitingTime;
      idTimerExpirationTime.current = setInterval(() => {
        timerExpirationTime();
      }, 1000);
      idTimerWaitingTime.current = setInterval(() => {
        timerWaitingTime();
      }, 1000);
    }

    if (res.status == "OTP Requests exceeded") {
      Swal.fire({
        showCloseButton: true,
        title: 'Reenvios OTP excedidos',
        text: "intente en 5 minutos.",
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        iconColor: "#fd6e0d",
        confirmButtonText: 'Entendido'
      }).then((result) => {
        if (result.isConfirmed) {
          route(-1);
        } else {
          route(-1);
        }
      });
    }

    if (res.status == "Contact already exists.") {

      Swal.fire({
        showCloseButton: true,
        title: 'Alerta',
        showCloseButton: true,
        text: `Este ${screen == "PhoneOTPScreen" ? "teléfono" : screen == "EmailOTPScreen" ? "correo electrónico " : ""} ya se encuentra registrado`,
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        iconColor: "#fd6e0d",
        confirmButtonText: 'Entendido'
      }).then((result) => {
        if (result.isConfirmed) {
          route(-1);
        } else {
          route(-1);
        }
      });
    }
    
  }

  function timerExpirationTime() {
    if (expirationTime == 0) clearInterval(idTimerExpirationTime.current);

    const minutes = Math.floor(expirationTime / 60);
    let seconds = expirationTime % 60;
    setexpirationTime(
      `${minutes < 10 ? "0" : ""}${minutes}:${seconds < 10 ? "0" : ""
      }${seconds}`
    );
    expirationTime = expirationTime - 1;
  }

  function timerWaitingTime() {
    if (waitingTime == 0) clearInterval(idTimerWaitingTime.current);

    const minutes = Math.floor(waitingTime / 60);
    let seconds = waitingTime % 60;
    setwaitingTime(
      `${minutes < 10 ? "0" : ""}${minutes}:${seconds < 10 ? "0" : ""
      }${seconds}`
    );

    waitingTime = waitingTime - 1;
  }

  const handleEnter = (event) => {
    
    const form = event.target.form;
    const index = [...form].indexOf(event.target);
    const val = form.elements[index].value;
    formik.setFieldValue(form.elements[index].name, val);

    if (
      event.key.toLowerCase() === "backspace" ||
      event.key.toLowerCase() === "arrowleft"
    ) {
      if (

        form.elements[index - 1] != undefined &&
        form.elements[index - 1].type == "tel"
      ) {
        form.elements[index - 1].focus();
        event.preventDefault();
      }
    } else {
      if (
        form.elements[index + 1] != undefined &&
        form.elements[index + 1].type == "tel"
      ) {
        console.log(form.elements[index + 1].values)
        form.elements[index + 1].focus();
        event.preventDefault();
      }
    }
  };

  async function _ContactInfoSave(data) {
    checkToken()
    let _return = false;
    setLoading(true);
    try {
      const dataContactInfoSave = await contactInfoSave(data);
      setLoading(false);
      const res = dataContactInfoSave.data;
      if (res.code == "PROCESS_OK") {
        return true;
      }
    } catch (error) {
      setLoading(false);
      const res = error.response.data;
      if (res.code == "NOT_FOUND") {
        Swal.fire({
          showCloseButton: true,
          title: 'Advertencia',
          text: "Código incorrecto",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#fd6e0d',
          iconColor: "#fd6e0d",
          confirmButtonText: 'Entendido'
        })
      }
    }
    return _return;
  }

  const formik = useFormik({
    initialValues: {
      code1: "",
      code2: "",
      code3: "",
      code4: "",
    },
    onSubmit: async (values) => {
      if (screen == "PhoneOTPScreen") {
        const data = {
          typeOfContactId: parameters.typeOfContactId,
          contact: parameters.contact,
          message: values.code1 + values.code2 + values.code3 + values.code4,
        };
        const _res = await _ContactInfoSave(data);
        if (_res) {
          route(-2)
        }
      }
      if (screen == "EmailOTPScreen") {
        const data = {
          typeOfContactId: parameters.typeOfContactId,
          contact: parameters.contact,
          message: values.code1 + values.code2 + values.code3 + values.code4,
          isPrincipal: parameters.isPrincipal,
        };
        const _res = await _ContactInfoSave(data);
        if (_res) {
          route(-2)
        }
      }
    },
    validate: (values) => {
      const errors = {};
      console.log(values);
      if (!values.code1) errors.code1 = "";
      if (!values.code2) errors.code2 = "";
      if (!values.code3) errors.code3 = "";
      if (!values.code4) errors.code4 = "";
      return errors;
    },
  });

  return (
    <>
      <FContainer>
        <form className="w-full">
          <div className="text-center pt-5 sm:pt-0">
            <div className="text-md pb-4 grid justify-center font-bold text-Secondary">
              <img
                src={require("../../components/assets/images/send-message.png")}
                className="w-28 sm:w-28"
              />
            </div>

            <div className="font-bold mt-1 text-large pb-2">
              {screen == "PhoneOTPScreen"
                ? "Enviamos un mensaje a tu móvil"
                : "Enviamos un mensaje de confirmacón"}
            </div>
            <div className="text-[14px] font-regular">
              {screen == "PhoneOTPScreen"
                ? "Ingresa el código que te mandamos al"
                : "Ingresa el código que te mandamos a"}
            </div>
            <div className="text-large pb-4 mt-3 grid justify-center font-bold  text-Secondary">
              {screen == "PhoneOTPScreen" ? (
                <FiconPhoneNumber
                  sizeIcon="25px"
                  phoneNumber={parameters.contact}
                />
              ) : (
                parameters.contact
              )}
            </div>
            <div className="text-left text-sm grid justify-center">
              <div>
                <div className="w-[65px] float-left">
                  <FInputt
                    type="tel"
                    name="code1"
                    maxLength="1"
                    formik={formik}
                    onKeyDown={handleEnter}
                    placeholder=""
                    className="w-full h-[58px] rounded-xl border-primary border-[2.5px] focus:bg-primary font-extrabold text-center text-[22px]"
                  />
                </div>
                <div className="w-16 float-left">
                  <FInputt
                    type="tel"
                    name="code2"
                    maxLength="1"
                    formik={formik}
                    onKeyDown={handleEnter}
                    placeholder=""
                    className="w-full h-[58px] rounded-xl border-primary border-[2.5px] focus:bg-primary font-extrabold text-center text-[22px]"
                  />
                </div>
                <div className="w-16 float-left">
                  <FInputt
                    type="tel"
                    name="code3"
                    maxLength="1"
                    formik={formik}
                    onKeyDown={handleEnter}
                    placeholder=""
                    className="w-full h-[58px] rounded-xl border-primary border-[2.5px] focus:bg-primary font-extrabold text-center text-[22px]"
                  />
                </div>
                <div className="w-16 float-left">
                  <FInputt
                    type="tel"
                    name="code4"
                    maxLength="1"
                    formik={formik}
                    onKeyDown={handleEnter}
                    placeholder=""
                    className="w-full h-[58px] rounded-xl border-primary border-[2.5px] focus:bg-primary font-extrabold text-center text-[22px]"
                  />
                </div>
              </div>
            </div>
            <div className="mt-2 text-sm grid justify-center">
              <div className="font-regular text-[13.5px]">
                <div className="float-left">
                  {"Expiración del código en"}&nbsp;
                </div>
                <div className="float-left font-bold text-Secondary">
                  {_expirationTime}
                </div>
              </div>
            </div>
            <div className="mt-2 text-sm grid justify-center">
              <div
                className={`${_waitingTime == "00:00" ? "grid place-items-center" : ""
                  } font-regular text-[13.5px]`}
              >
                <div className="float-left ">
                  {_waitingTime == "00:00"
                    ? "¿No has podido validar tu número?"
                    : "Solicita nuevo código en"}
                  &nbsp;
                </div>
                <div className="float-left font-bold text-Secondary">
                  {_waitingTime == "00:00" ? (
                    <div
                      className="cursor-pointer hover:underline"
                      onClick={_SingUpSendCode}
                    >
                      Solicita un nuevo código
                    </div>
                  ) : (
                    _waitingTime
                  )}
                </div>
              </div>
            </div>
            <div className="m-4 pb-4 sm:pb-0">
              <Fbutton
                value={"Continuar"}
                disabled={(!(formik.isValid && formik.dirty) || _expirationTime == "00:00")}
                onClick={formik.handleSubmit}
              />
            </div>
          </div>
        </form>
      </FContainer>
    </>
  );
};

export default OTPToken;
